import dropdown from './dropdown.component';

export default angular
  .module('fizyweb.paycell.dropdown', [])
  .component('dropDown', dropdown).name;



// WEBPACK FOOTER //
// src/app/components/dropdown/dropdown.module.ts